import type { ILearningGrainRepository } from '@/core/domain/learning/grain/ILearningGrainRepository.ts'
import type { UploadedSupportFile } from '@/core/infrastructure/schemas/learning/support/UploadedSupportFileSchema.ts'

export class UploadLearningSupportFileUseCase {
  private readonly learningGrainRepository: ILearningGrainRepository

  constructor(learningGrainRepository: ILearningGrainRepository) {
    this.learningGrainRepository = learningGrainRepository
  }

  async execute(
    courseId: number,
    moduleId: number,
    grainId: number,
    file: File
  ): Promise<UploadedSupportFile> {
    return this.learningGrainRepository.uploadSupportFile(courseId, moduleId, grainId, file)
  }
}
